module.exports = __webpack_public_path__ + "static/media/managers-guide2.b788db95.png";